import { qs } from "@/utils/dom";

const VISIBLE_AFTER_PX = 400;
const HIDDEN_CLASSES = ["opacity-0", "translate-y-2", "pointer-events-none"];
const VISIBLE_CLASSES = ["opacity-100", "translate-y-0", "pointer-events-auto"];

export function initScrollToTop(): void {
  const button = qs<HTMLButtonElement>("[data-scroll-to-top]");
  if (!button) return;

  const updateVisibility = () => {
    const isVisible = window.scrollY > VISIBLE_AFTER_PX;
    button.classList.remove(...(isVisible ? HIDDEN_CLASSES : VISIBLE_CLASSES));
    button.classList.add(...(isVisible ? VISIBLE_CLASSES : HIDDEN_CLASSES));
  };

  window.addEventListener("scroll", updateVisibility, { passive: true });
  button.addEventListener("click", () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  });

  updateVisibility();
}
